// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messageButtonHeight[data-v-046ea33c] button {\n  height: 34px;\n}", ""]);
// Exports
module.exports = exports;
